import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from "react";
export function ShareIcon(t0) {
  const $ = _c(14);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      color: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const color = t1 === undefined ? "currentColor" : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <title>Share</title>;
    t3 = <circle cx="18" cy="5" r="3" />;
    t4 = <circle cx="6" cy="12" r="3" />;
    t5 = <circle cx="18" cy="19" r="3" />;
    t6 = <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />;
    t7 = <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] !== className || $[11] !== color || $[12] !== props) {
    t8 = <svg className={className} fill="none" height={40} stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width={40} xmlns="http://www.w3.org/2000/svg" {...props}>{t2}{t3}{t4}{t5}{t6}{t7}</svg>;
    $[10] = className;
    $[11] = color;
    $[12] = props;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}